import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllOutbound() {
  try {
    let res = await client.get("/outbound");

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function fetchAllOutboundByType(type, date) {
  try {
    let res = await client.get(`/outbound?type=${type}&date_scan=${date}`);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function fetchOneOutbound(id) {
  try {
    let res = await client.get("/outbound/outbound_id/" + id);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function createOutbound(purpose, request_by, outbound_item) {
  try {
    let res = await client.post("/outbound/create", {
      // purpose: purpose,
      // request_by: request_by,
      outbound_item: outbound_item.map((data) => {
        return {
          part: data.part,
          rfid: data.rfid,
          qty: data.qty,
        };
      }),
    });
    console.log(res.data);
    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function createRequestOutbound(
  outbound_item_id,
  rfid,
  qty,
  production_date
) {
  try {
    let res = await client.post("/outbound/item_out", {
      outbound_item_id: outbound_item_id,
      rfid: rfid,
      qty: qty,
      production_date: production_date,
    });

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function checkRFID(rfid_number) {
  try {
    let res = await client.get(
      `/outbound/check-rfid?rfid_number=${rfid_number}`
    );

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

async function deleteOutbound(id) {
  try {
    let res = await client.delete("/outbound/outbound_id/" + id);

    return res.data;
  } catch (err) {
    throw ErrorException(err);
  }
}

export {
  fetchAllOutbound,
  fetchAllOutboundByType,
  fetchOneOutbound,
  createOutbound,
  createRequestOutbound,
  checkRFID,
  deleteOutbound,
};
